import { useTranslation } from "react-i18next"
import secondsToHms from "../../../../utility/SecondToHms"


function AbsenceRequestDetailTable({ absenceRequest }) {

    const [t] = useTranslation(["global", "absenceReport"])

    function sortByDate(a, b) {
        return a.startDate - b.startDate
    }

    const orderedItems = [...absenceRequest]
    orderedItems.sort(sortByDate)

    let items = orderedItems.map((absenceReports, i) => {

        const absenceTypeIcon = () => {
            switch (absenceReports.type) {
                case "HOLIDAY": return <i className="fa-solid fa-umbrella-beach"></i>
                case "SICK": return <i className="fa-solid fa-house-chimney-medical"></i>
                case "PERMIT": return <i className="fa-solid fa-clock"></i>
                default: return
            }
        }

        const absenceTypeLabel = () => {
            switch (absenceReports.type) {
                case "HOLIDAY": return t("absenceReport:entity.absence.reason.holidays")
                case "SICK": return t("absenceReport:entity.absence.reason.sick")
                case "PERMIT": return t("absenceReport:entity.absence.reason.permitt")
                default: return t("absenceReport:entity.absence.reason.other")
            }
        }

        return (

            <section key={i}>
                <hr />
                <div className={`row ${absenceReports.wlh ==0 && "opacity-25"}`}>

                    <div className="col-sm">
                        {absenceReports.userDisplayName}
                    </div>

                    <div className="col-sm text-end">
                        <div>
                            <h5> {absenceTypeLabel()} {absenceTypeIcon()}</h5>
                        </div>

                    </div>
                    <div className="col-sm">
                        <p>
                            <b>dal </b>{new Date(absenceReports.startDate * 1000).toLocaleDateString()}<br />
                            <b>al </b> {new Date(absenceReports.endDate * 1000).toLocaleDateString()}
                        </p>
                    </div>


                    <div className={`col-sm ${absenceReports.note ? '' : ''}`}>

                        <h4>{absenceReports.days}</h4>
                    </div>
                    <div className="col-sm">
                        <h4>{secondsToHms(absenceReports.hours)}</h4>
                    </div>
                    <div className="col-sm bg-light bg-opacity-25">
                        <h4>- {(Math.round(absenceReports.wlh * 100) / 100).toFixed(1)} h</h4>
                    </div>
                </div>



            </section>
        );
    })

    return (
        items.length > 0 ?
            <section>
                <div className="card bg-black bg-opacity-10 text-white mb-4">
                    <div className="card-header">
                        <i className="fa-solid fa-magnifying-glass"></i> {t("absenceReport:menu.details")}
                    </div>

                    <div className="card-body text-end">

                        <div className="row opacity-50">
                            <div className="col-sm">
                                {t("entity.employee")}
                            </div>
                            <div className="col-sm">
                                {t("absenceReport:property.reason")}
                            </div>
                            <div className="col-sm">
                                {t("property.period")}
                            </div>
                            <div className="col-sm">
                                <i className="fa-solid fa-calendar-days"></i> {t("property.days")}
                            </div>
                            <div className="col-sm">
                                <i className="fa-regular fa-clock"></i> {t("property.hours")}
                            </div>
                            <div className="col-sm">
                                <i className="fa-regular fa-clock"></i> WorkOff
                            </div>
                            <br />
                        </div>{items}
                    </div>

                </div>
            </section> : null


    )


}

export default AbsenceRequestDetailTable

